import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAction,
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
} from '../../procedures/childbirthOB/store/childbirthOB.actions'
import { setAddChildbirthOBToTimeline } from '../store/quickActions.actions'
import { getChildbirthOBOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { IChildbirthOBOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { IOption } from '../../../common/common.types'

export function* setChildbirthQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const childbirthOBOptions: IChildbirthOBOptionsState = yield select(getChildbirthOBOptionsSelector)
  const { actionOptions } = childbirthOBOptions

  const actionOption = actionOptions.find((option: IOption) => option.id === procedureAction)
  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddChildbirthOBToTimeline(true))
  yield put(setAction(actionOption ? actionOption : null))
}

export function* setChildbirthQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_CHILDBIRTHOB_BUTTON_TYPE], setChildbirthQuickAction)
}
